import PropTypes from 'prop-types'

import ModelListModel from './ModelListModel'

import s from './ModelList.module.css'

function ModelList({
  models = [],
  group = '',
  boardSlug = '',
  showFollowers = false,
}) {
  return (
    <>
      <div className={s.container}>
        {models.length > 0 &&
          models
            .filter(({ image }) => image?.defaultColor !== 'false')
            .map((model) => (
              <ModelListModel
                {...model}
                key={model.id}
                group={group}
                href={`${group}/${boardSlug}/${model.slug}`}
                withBoard
                showFollowers={showFollowers}
              />
            ))}
      </div>
      {models.length < 1 && (
        <div className={s.noItems}>
          <p>
            We do not currently have any models matching your requested criteria
          </p>
        </div>
      )}
    </>
  )
}

ModelList.propTypes = {
  models: PropTypes.array,
  boardSlug: PropTypes.string,
  group: PropTypes.string,
  showFollowers: PropTypes.bool,
}

export default ModelList
